import { ExportButtonDropdown, ExportType } from '@components'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'
import { useExportProducts } from '@features/products/hooks/useExportProducts'
import { useTrackProductsExport } from '@features/products/hooks/useTrackProductsExport'

import { useOrganizationSource } from '../../../../hooks'
import { ExportsCard } from '../ExportsCard'

const PRODUCTS_EXPORT_URL = 'products'

export const Products = () => {
  const { t } = useTranslation()
  const { downloadExportFile } = useDownloadExportFile()
  const { isSourceZervant } = useOrganizationSource()
  const { exportProducts, isLoading } = useExportProducts({ enabled: isSourceZervant })
  const { trackProductsExport } = useTrackProductsExport()

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      if (isSourceZervant) {
        exportProducts(type === ExportType.Xlsx ? ExportType.Xlsx : ExportType.Csv)
        return
      }

      downloadExportFile({
        exportUrl: PRODUCTS_EXPORT_URL,
        type,
      })
      trackProductsExport({ fileFormat: type })
    },
    [downloadExportFile, exportProducts, isSourceZervant, trackProductsExport],
  )

  return (
    <ExportsCard
      description={t('exports.card.products.description')}
      title={t('exports.card.products.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html, ExportType.Pdf]}
          loading={isSourceZervant && isLoading}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    />
  )
}
